import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';

const constructOrderStatusOptions = (orderStatus, orderType) => {
    let orderStatusOptions = [{ id: orderStatus, label: getStatusDescriptionFromStatusValue(orderStatus) }]
    if ((orderStatus === 'ORDER_RECEIVED' || orderStatus === 'ORDER_SENT' || orderStatus === 'ORDER_SUBMITTED') && orderType === "1") {
        orderStatusOptions.push({ id: "ASSETS_COLLECTED", label: "Assets Collected" });
    }
    else if (((orderStatus === 'ORDER_RECEIVED' || orderStatus === 'ORDER_SENT' || orderStatus === 'ORDER_SUBMITTED') && orderType === "2") || orderStatus === 'ASSETS_COLLECTED' && orderType === "1") {
        orderStatusOptions.push({ id: "ASSETS_RECEIVED", label: "Assets Received" });
    }
    return orderStatusOptions;
}

const revitalizeOrderOptions = [
    { id: "NO", label: "No" },
    { id: "YES", label: "Yes" }
]

const getReportingYearOptions = (createdDate) => {
    const createdYear = new Date(createdDate).getFullYear();
    const currentYearNumber = new Date().getFullYear();
    const options = [];
    for (let year = createdYear; year <= currentYearNumber; year++) {
        options.push({ id: `FY${year.toString().slice(-2)}`, label: `FY${year.toString().slice(-2)}` });
    }
    return options;
}

const getReportingQuarterOptions = (reportingYear) => {
    if (reportingYear === '') return [];
    const year = reportingYear?.slice(2) || new Date().getFullYear().toString().slice(-2);
    const options = [];
    for (let quarter = 1; quarter <= 4; quarter++) {
        options.push({ id: `FY${year}Q${quarter}`, label: `FY${year}Q${quarter}` });
    }
    return options;
}

const getReportingMonthOptions = (reportingQuarter) => {
    if (reportingQuarter === '') return [];
    const quarterStartMonths = {
        'Q1': 11, // November (month 11)
        'Q2': 2,  // February (month 2)
        'Q3': 5,  // May (month 5)
        'Q4': 8   // August (month 8)
    };

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const options = [];

    if (reportingQuarter) {
        const quarter = reportingQuarter.slice(-2); // Extract 'Q1', 'Q2', etc.
        const year = reportingQuarter.slice(2, 4); // Extract year part
        const startMonth = quarterStartMonths[quarter];

        for (let i = 0; i < 3; i++) {
            const monthIndex = (startMonth - 1 + i) % 12;
            const monthName = monthNames[monthIndex];
            options.push({ id: `${monthName}FY${year}${quarter}`, label: `${monthName}FY${year}${quarter}` });
        }
    }

    return options;
}



export default function directCustomerOrderListColumnsSpecification(config) {
    if (!config.data) return null;
    const { orderList = [], userType, mobile, userList, serviceTypes } = config.data;

    let result = {};
    let tableData = [];

    const getUserList = () => {
        const users = userList || [];
        const userOptions = users.map(user => ({ id: `${user.emailAddress}`, label: `${user.emailAddress}` }));
        return [{ id: "", label: "" }, ...userOptions];
    }

    const getServiceTypeList = () => {
        const serviceTypesList = serviceTypes || [];
        const serviceTypeOptions = serviceTypesList?.map(serviceType => ({ id: `${serviceType}`, label: `${serviceType}` }));
        return [{ id: "", label: "Select service type" }, ...serviceTypeOptions];
    }

    orderList.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let columnValue = null;
            let columnValueData = null;
            let setColumnValue = null;
            let linkDestination = null;
            let isDisabled = false;
            if (columnDataType === "string") {
                if (columnId === "creationDate") {
                    columnValue = getDateWithSpecificFormat(order.createdDate);
                    setColumnValue = columnValue;
                }
                if (columnId === "derivedCtQuoteId") {
                    columnValue = order.derivedCtQuoteId || "";
                    setColumnValue = columnValue;
                }
                if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                    setColumnValue = columnValue;
                }
                if (columnId === "country") {
                    columnValue = order.countryCode ? getCountryNameByCountryCode(order.countryCode) : "";
                    setColumnValue = columnValue;
                }
                if (columnId === "company") {
                    columnValue = order.company || "";
                    setColumnValue = columnValue;
                }
                if (columnId === "legalEntityName") {
                    columnValue = order.legalEntity || "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "collectionCity") {
                    columnValue = order.collectionCity || "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "totalAssetsQuoted") {
                    columnValue = order.qtyOfAssetsRequested ? order.qtyOfAssetsRequested : 0;
                    setColumnValue = columnValue;
                }
                else if (columnId === "currency") {
                    columnValue = order.currencyCode || "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "vendorQuotedNetValue") {
                    columnValue = order.quotedVendorNetValue !== null ? order.quotedVendorNetValue?.toFixed(2) : "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "vendorFinalNetValue") {
                    columnValue = order.finalVendorNetValue !== null ? order.finalVendorNetValue?.toFixed(2) : "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "customerQuotedNetValue") {
                    columnValue = order.quotedNetValue !== null ? order.quotedNetValue?.toFixed(2) : "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "customerFinalNetValue") {
                    columnValue = order.finalNetValue !== null ? order.finalNetValue?.toFixed(2) : "";
                    setColumnValue = columnValue;
                }
                else if (columnId === "reportingStatus") {
                    if (order.status === 'ORDER_SUBMITTED' || order.status === 'ASSETS_COLLECTED' || order.status === 'ASSETS_RECEIVED') {
                        columnValue = getStatusDescriptionFromStatusValue("NOT_AVAILABLE");
                        setColumnValue = columnValue;
                    }
                    else {
                        columnValue = order.reportingStatus ? getStatusDescriptionFromStatusValue(order.reportingStatus) : "";
                        setColumnValue = columnValue;
                    }
                }
                else if (columnId === "paymentStatus") {
                    columnValue = columnValue = order.paymentStatus ? getStatusDescriptionFromStatusValue(order.paymentStatus) : "";
                    setColumnValue = columnValue;
                }
                else if (column.id === "currencyCode") {
                    columnValue = order.currencyCode || "";
                    setColumnValue = columnValue;
                }
                else if (column.id === "vendorName") {
                    columnValue = order.vendorName || "";
                    setColumnValue = columnValue;
                }
                else if (column.id === "quantityOfRevlitizeAssets") {
                    columnValue = order.numberOfRevitalizeAssets || "";
                    setColumnValue = columnValue;
                    if (order.revitalizeQuote === 'NO' && order.revitalizeOrder === 'NO') {
                        isDisabled = true
                    }
                }
                else if (column.id === "revitalizeQuote") {
                    columnValue = getStatusDescriptionFromStatusValue(order.revitalizeQuote) || "";
                    setColumnValue = columnValue;
                    if (order.vendorName !== 'TES') {
                        isDisabled = true
                    }
                }
                else if (columnId === "portalOrder") {
                    columnValue = order.portalOrder || "";
                    setColumnValue = columnValue;
                }
            }
            else if (columnDataType === "link") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                    setColumnValue = columnValue;
                    linkDestination = '/my-orders/direct-customer/order-detail/' + order.orderId;
                }
            }
            else if (columnDataType === "input") {
                if (columnId === "vendorOrderId") {
                    columnValueData = { ...column.data };
                    columnValue = order.vendorOrderId || "";
                    columnValueData.defaultValue = columnValue;
                    if (userType === 'Vendor' && order.vendorOrderIdAvail === "Y") {
                        isDisabled = true;
                    }
                    setColumnValue = mobile ? columnValueData.defaultValue : columnValueData;
                }
                if (columnId === "collectionDate") {
                    columnValueData = { ...column.data };
                    columnValue = order.collectionDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate];
                    setColumnValue = columnValueData;

                    if (order.orderType === "2") {
                        isDisabled = true
                    } else if (order.orderType === "1" && (order.status === 'ORDER_SUBMITTED' || order.status === 'ORDER_SENT' || order.status === 'ORDER_RECEIVED')) {
                        isDisabled = false
                    } else if (!order.collectionDate) {
                        isDisabled = false
                    } else {
                        isDisabled = true
                    }

                }
                if (columnId === "assetsReceiptDate") {
                    columnValueData = { ...column.data };
                    columnValue = order.assetsReceiptDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableAfterDates = new Date();
                    isDisabled = true;
                    setColumnValue = columnValueData;

                    if (order.orderType === "2" && (order.status === 'ORDER_SUBMITTED' || order.status === 'ORDER_SENT' || order.status === 'ORDER_RECEIVED')) {
                        columnValueData.disableBeforeDates = [order.createdDate];
                        isDisabled = false
                    } else if (order.orderType === "1" && order.status === 'ASSETS_COLLECTED' && order.collectionDate) {
                        columnValueData.disableBeforeDates = [order.collectionDate];
                        setColumnValue = columnValueData;
                        isDisabled = false;
                    }
                }
                if (columnId === "expectedReportDate") {
                    columnValueData = { ...column.data };
                    columnValue = order.expectedReportDate || "";
                    columnValueData.defaultValue = columnValue;
                    setColumnValue = columnValueData;
                    if (!order.assetsReceiptDate) {
                        columnValueData.disableBeforeDates = [order.createdDate];
                    }
                    if (order.assetsReceiptDate) {
                        columnValueData.disableBeforeDates = [order.assetsReceiptDate];
                    }
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "owner") {
                    columnValue = order.owner || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = userType === 'Vendor' ? [{ id: order.owner, label: order.owner }] : getUserList();
                    setColumnValue = columnValueData;
                    if (userType !== 'ControlTower') {
                        isDisabled = true;
                    }
                }
                if (columnId === "serviceType") {
                    columnValue = order.serviceType || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = getServiceTypeList();
                    setColumnValue = columnValueData;
                    if (userType !== 'ControlTower') {
                        isDisabled = true;
                    }
                }
                if (columnId === "reportingYear") {
                    columnValue = order.reportingYear || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select year" }, ...getReportingYearOptions(order.createdDate)];
                    setColumnValue = columnValueData;
                }
                if (columnId === "reportingQuarter") {
                    columnValue = order.reportingQuarter || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select quarter" }, ...getReportingQuarterOptions(order.reportingYear)];
                    setColumnValue = columnValueData;
                    isDisabled = !order.reportingYear ? true : false;
                }
                if (columnId === "reportingMonth") {
                    columnValue = order.reportingMonth || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select month" }, ...getReportingMonthOptions(order.reportingQuarter)];
                    setColumnValue = columnValueData;
                    isDisabled = !order.reportingQuarter ? true : false;
                }
                if (columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(order.status) || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    const paymentStatusDropDownOptions = constructOrderStatusOptions(order.status, order.orderType);
                    columnValueData.options = paymentStatusDropDownOptions;
                    setColumnValue = columnValueData;
                }
                if (columnId === "revitalizeOrder") {
                    columnValue = order.revitalizeOrder
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;

                    //Vendor profile
                    if (userType === 'Vendor' && order.revitalizeQuote === 'NO' && !order.revitalizeOrder) {
                        columnValueData.options = [
                            { id: order.revitalizeOrder, label: getStatusDescriptionFromStatusValue(order.revitalizeOrder) },
                            ...revitalizeOrderOptions
                        ];
                    }
                    else if (userType === 'Vendor' && order.revitalizeQuote === 'NO' && order.revitalizeOrder === 'NO') {
                        columnValueData.options = [...revitalizeOrderOptions];
                    }
                    else if (userType === 'Vendor' && order.revitalizeQuote === 'NO' && order.revitalizeOrder === 'YES') {
                        columnValueData.options = [...revitalizeOrderOptions];
                        isDisabled = true;
                    }

                    //Vendor profile and exceptional order
                    if ((userType === 'Vendor' || userType === 'ControlTower') && order.checkoutOption === 'EXCEPTIONAL' && !order.revitalizeOrder) {
                        columnValueData.options = [
                            { id: order.revitalizeOrder, label: getStatusDescriptionFromStatusValue(order.revitalizeOrder) },
                            ...revitalizeOrderOptions
                        ];
                    }
                    else if ((userType === 'Vendor' || userType === 'ControlTower') && order.checkoutOption === 'EXCEPTIONAL' && order.revitalizeOrder) {
                        columnValueData.options = [
                            ...revitalizeOrderOptions
                        ];
                        if (userType === 'Vendor' && order.revitalizeOrder === 'YES') {
                            isDisabled = true;
                        }
                    }

                    else if (userType === 'Vendor' && order.revitalizeQuote === 'YES') {
                        isDisabled = true;
                        columnValueData.options = [
                            { id: order.revitalizeOrder, label: getStatusDescriptionFromStatusValue(order.revitalizeOrder) },
                            ...revitalizeOrderOptions
                        ];
                    }
                    else if (userType === 'Vendor' && order.revitalizeQuote === 'NO' && !order.revitalizeOrder) {
                        columnValueData.options = [...revitalizeOrderOptions];
                    }
                    else if (userType === 'Vendor' && order.revitalizeQuote === 'NO' && order.revitalizeOrder === 'YES') {
                        isDisabled = true;
                        columnValueData.options = [...revitalizeOrderOptions];
                    }
                    else if (order.revitalizeQuote && !order.revitalizeOrder) {
                        columnValueData.options = [
                            { id: order.revitalizeOrder, label: getStatusDescriptionFromStatusValue(order.revitalizeOrder) },
                            ...revitalizeOrderOptions
                        ];
                    }
                    else if (order.revitalizeQuote && order.revitalizeOrder) {
                        columnValueData.options = [...revitalizeOrderOptions];
                    }
                    if (order.vendorName !== 'TES') {
                        isDisabled = true
                    }
                    setColumnValue = columnValueData;
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    highlightColumn: highlightColumn,
                    linkDestination: linkDestination,
                    value: setColumnValue,
                    showInMobileViewAs: column.showInMobileViewAs,
                    disabledCell: isDisabled,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
